'use client'
import { dispatch, useSelector } from '@/lib/store'
import { updateCommonReducerData } from '@/lib/reducers/commonReducer'
import { IMAGING_TEST_DATA } from '@/helper/DATA'

// Opens the request-callback modal in radiology mode; no destination page exists, so buttons (not links) are correct here.
const HealthScansAndImagingTestSection = () => {
  const commonState = useSelector((state) => state.common) || {}

  const openRadiologyLeadForm = (testName: string) => {
    dispatch(
      updateCommonReducerData({
        ...commonState,
        requestCallbackModalIsOpen: {
          modalIsOpen: true,
          type: testName,
        },
      })
    )
  }

  return (
    <section id="popular-radiology-tests" className="py-6 text-center">
      <h3 className="tracking-tight text-heading-sm lg:text-heading-md font-semibold text-gray-900 mb-3 lg:mb-5">
        Most Popular Radiology Tests
      </h3>
      <div className="flex flex-wrap items-center justify-center divide-x divide-gray-100 gap-y-1">
        {IMAGING_TEST_DATA.map((item, index) => (
          <button
            key={`${item.name}-${index}`}
            type="button"
            onClick={() => openRadiologyLeadForm(item.name)}
            className="text-body-xs lg:text-body-sm text-gray-600 font-medium leading-4 lg:leading-6 px-3 my-0.5 hover:text-primary-600"
          >
            {item.name}
          </button>
        ))}
      </div>
    </section>
  )
}

export default HealthScansAndImagingTestSection
